import axios from "axios";
import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { useAlert } from "react-alert";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
//import "../../LearningResources/styles/LearningResources.css";

import { LearningContentLayout } from "../../shared/ui/Learning/LearningContentLayout.jsx";
import { TopicList } from "../../shared/domain/learning/components/TopicList.jsx";

import { GlobalContext } from "../../context/GlobalState.jsx";
import { decodeHTMLEntities, cleanURLPath } from "../../shared/utils/url.js";

export default function AssessmentTopics() {
  document.title = "2xcell.in";
  const history = useHistory();
  // fetching topics of chapters using subect ID
  // loading for chapters
  const [topicList, setTopicList] = useState([]);
  const params = useParams();
  const subjectName = decodeHTMLEntities(params.subjectName);
  const chapterName = decodeHTMLEntities(params.chapterName);
  const alert = useAlert();
  const { userDetails, setUserDetails, gradeSection } = useContext(GlobalContext);

  const [fetched, setFetched] = useState(false);

   const openChapter = (topic) => {
    history.push(
      `/myassessment/practice/subjects/${params.subjectId}/${cleanURLPath(
        subjectName,
      )}/chapters/${params.chapterId}/${cleanURLPath(chapterName)}/assessment?category=cbq`
    );
  };

  const openTopic = (topic) => {
    history.push(
      `/myassessment/practice/subjects/${params.subjectId}/${cleanURLPath(
        subjectName,
      )}/chapters/${params.chapterId}/${cleanURLPath(chapterName)}/assessment?topicId=${
        topic._id
      }&topicName=${cleanURLPath(topic.name)}`
    );
  };

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    const apiForTopics = `${process.env.REACT_APP_ORIGIN}/api/v1/chapters/${params.chapterId}`;
    axios
      .get(apiForTopics, {
        headers: {
          token: authToken,
        },
      })
      .then((resp) => {

        let topics = resp.data.data.chapter.totalTopics
          ? resp.data.data.chapter.topics.filter(
              (item) => item?.lang === window.localStorage.getItem("language"),
            )
          : [];
        setTopicList(topics);
        setFetched(true);
      })
      .catch((err) => {
        alert.error("Topics not fetched");
      });
  }, []);

  useEffect(() => {
    setUserDetails({ ...userDetails, selectedTab: "My Assessment" });
    setUserDetails({
      ...userDetails,
      selectedPath: {
        subject: subjectName,
        chapter: chapterName,
        topic: "",
      },
    });
  }, []);

  return (
    <LearningContentLayout
      grade={gradeSection}
       page={"Practice Assessment"}
      resourcePage={subjectName + " > " + chapterName + "> Topics"}
    >
      <button style={{padding:"5px 10px",fontSize:"1.1rem",fontWeight:"bold",color:"white",backgroundColor:"#2497f4", borderRadius:"5px","margin":"10px 0"}} onClick={openChapter}>Practice Competency Questions</button>
      <TopicList loading={fetched} topics={topicList} onClick={openTopic} />
    </LearningContentLayout>
  );
}
